export default "__VITE_ASSET__24216612__"